import { createContext, useContext } from 'react';

import type { CustomTestCreateWizardContextValue } from 'pages/custom_tests_v1/components/custom_test_create_wizard/CustomTestCreateWizard';

export const CustomTestCreateWizardContext = createContext({} as CustomTestCreateWizardContextValue);
CustomTestCreateWizardContext.displayName = 'CustomTestCreateWizardContext';

export const useCustomTestCreateWizard = () => useContext(CustomTestCreateWizardContext);